import { ReactNode } from 'react';
import { Row } from './MainWrap.styled';

interface props {
  children: ReactNode;
}

export const MainWrap = ({ children }: props) => {
  return <Row>{children}</Row>;
};
